<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/68jijB/tc-custom/9781429982283.jpg?1724854657685" alt="This image is the cover for the book Alien Emergencies, The Sector General Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alien Emergencies, The Sector General Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The second three volumes of James White's Sector General SF saga, in a single omnibus edition.</b><br/><br/>Sector General: A vast hospital complex in the depths of outer space. The thousands who work there, human and alien both, have a single mission: To care for all patients, of all species. At Sector General, anything can happen-and frequently does.<br/><br/>James White's tales of Sector General are lively, humorous, and humane, at times shot through with a healer's anger at violence and destruction. These are endlessly inventive dramas of civility and spirituality, tempered with White's gently wicked wit and his keen eye for the remarkable in the everyday.<br/><br/>Now, in a single omnibus, the second three volumes of the series-Ambulance Ship, Sector General, <i>and </i>Star Healer-return to print in complete and corrected editions, including a sequence ("Spacebird") omitted from previous American editions of <i>Ambulance Ship</i>. The volume is introduced by Hugo-winning SF writer and critic David Langford. <br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James White, David Langford
      </h2>
      
      <p class="authorDescription body article"><P><B>James White</B> lived in Northern Ireland. He was a popular writer of science fiction for over forty years. He died in 1999.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08638c2b